import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import DefaultFormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const jypCityChoices = [
  {
    value: 'ALIGARH',
    label: 'Aligarh',
  },
  {
    value: 'ALLAHABAD',
    label: 'Allahabad',
  },
  {
    value: 'DELHI',
    label: 'Delhi',
  },
  {
    value: 'DEHRADUN',
    label: 'Dehradun',
  },
  {
    value: 'GORAKHPUR',
    label: 'Gorakhpur',
  },
  {
    value: 'HISAR',
    label: 'Hisar',
  },
  {
    value: 'KANPUR',
    label: 'Kanpur',
  },
  {
    value: 'LUCKNOW',
    label: 'Lucknow',
  },
  {
    value: 'MEERUT',
    label: 'Meerut',
  },
  {
    value: 'PATNA',
    label: 'Patna',
  },
  {
    value: 'RANCHI',
    label: 'Ranchi',
  },
  {
    value: 'VARANASI',
    label: 'Varanasi',
  },
];

class CitySelector extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    addOverall: PropTypes.bool,
    initialValue: PropTypes.string,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    onChange: () => {},
    addOverall: false,
    initialValue: '',
    disabled: false,
  };

  state = {
    jypCities: [],
    citySelected: this.props.initialValue || '',
  };

  componentDidMount() {
    const jypCities = jypCityChoices;
    if (this.props.addOverall) {
      this.setState({
        jypCities: [{ value: 'OVERALL', label: 'Overall' }, ...jypCities],
      });
    } else {
      this.setState({ jypCities });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.citySelected !== prevState.citySelected) {
      this.props.onChange(this.state.citySelected);
    }
  }

  render() {
    const { disabled } = this.props;

    return (
      <FormControl disabled={disabled}>
        <InputLabel htmlFor="jyp-cities">JYP City</InputLabel>
        <Select
          value={this.state.citySelected}
          onChange={(event) => {
            this.setState({ citySelected: event.target.value });
          }}
        >
          {this.state.jypCities.map(city => (
            <MenuItem key={city.value} value={city.value}>
              {city.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

export default CitySelector;

const FormControl = styled(DefaultFormControl)`
  && {
    min-width: 200px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/CitySelector/CitySelector.js